import React, { useState, useEffect, Fragment, useCallback } from 'react'
import swal from 'sweetalert'
import { permissions } from 'settings/permissions'
import { superAxiosRequest } from 'axiosApi'
import Stores from 'Stores'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import EmptyBalance from './EmptyBalance'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import st from './ClientBalances.module.scss'
import { ReactComponent as TopUpIcon } from './img/top_up.svg'
import useLocalization from 'hooks/useLocalization'
import asideModalStore from 'Stores/asideModalStore'
import CreateBalance from 'components/ContentBox/Global/GlobalModalSingle/templates/Pays/CreateBalance'
import Refunds from 'components/ContentBox/Global/GlobalModalSingle/templates/Pays/Refunds'
import AddMoney from '../../../../Global/GlobalModalSingle/templates/InterpressMoney/AddMoney'

export default function ClientBalances(props) {
  const clientID = +props.id

  const { checkUser } = Stores

  const [companyId, setCompanyId] = useState(null)
  const [balance, setBalance] = useState([]) // [Компания, бонусный, группы]

  const fetchBalances = useCallback(() => {
    const apiConf = {
      method: 'get',
      link: 'ledger/get_client_balance',
      params: {
        client_id: clientID,
      },
    }
    superAxiosRequest(apiConf).then(({ data }) => {
      setBalance([
        data.company_balances,
        data.bonus_balance,
        data.group_balances,
      ])
      data.company_balances.length > 0 &&
        setCompanyId(data.company_balances[0].company.id)
    })
  }, [clientID])

  const onChangeCompanyHandler = (company_id) => {
    setCompanyId(company_id)
  }

  const func = (data) =>
    setBalance([data.company_balances, data.bonus_balance, data.group_balances])

  // Пополнение баланса
  const topUp = (name, student_group_rel, isCompany) => {
    const ms = {
      name: 'addPayment',
      link: 'payments/pay_orders',
      button: 'Добавить',
      title: `Пополнение баланса: ${name}`,
      type: 'addPayment',
      isResponsive: true,
      locked: true,
      client_id: props.id,
      ...(checkUser() && {
        onSubmitSuccess: (res) =>
          (window.location.href = '/pays/invoice/' + res.order_id),
      }),
      valid: {
        amount: 'more_than_100',
      },
    }
    asideModalStore.activity(
      ms,
      isCompany
        ? {
            company: student_group_rel,
            status_sending_mail: 'need_mail',
            amount: 0,
            client_id: props?.id,
          }
        : {
            student_group_rel,
            status_sending_mail: 'need_mail',
            amount: 0,
            client_id: props?.id,
          },
    )
  }

  // Возврат средств
  const refund = (id, max_sum, type_operation, name) => {
    let ms = {
      modalBodyComponent: () => <Refunds translate={translate} />,
      link: 'payments/refunds',
      button: translate.transfer,
      title: `Возврат средств: ${name}`,
      onSubmitSuccess: (data) => {},
      isResponsive: true,
      max_sum,
      id,
    }

    const bo = {
      client: props.id,
      refund: true,
      sum: max_sum,
      ...(type_operation === 'company' && { company_from: id }),
      ...(type_operation === 'group' && { group_balance_from: id }),
    }

    asideModalStore.activity(ms, bo)
  }

  //Transfer to student
  const transferStudent = (id, sum) => {
    const ms = {
      modalBodyComponent: () => <Refunds translate={translate} />,
      link: 'payments/company_balance_transfer',
      button: translate.transfer,
      title: `${translate.transfer_to_student}:`,
      onSubmitSuccess: (data) => {
        setBalance(
          balance.map((balance, index) => (index === 0 ? [data] : balance)),
        )
      },
      isResponsive: true,
      sendToClient: true,
    }

    const bo = {
      id,
      sum,
    }

    asideModalStore.activity(ms, bo)
  }

  // Перевод средств
  const transfer = (id, max_sum, type_operation, name) => {
    const ms = {
      modalBodyComponent: () => <Refunds translate={translate} />,
      link: 'payments/refunds',
      button: translate.transfer,
      title: `Перевод средств: ${name}`,
      onSubmitSuccess: (data) => {},
      isResponsive: true,
      send: true,
      type_operation,
      payload: {
        companies: balance[0],
        groups: balance[2],
      },
    }

    const bo = {
      client: clientID,
      sum: max_sum,
      ...(type_operation === 'company' && { company_from: id }),
      ...(type_operation === 'bonus_balance' && { company_id: companyId }),
      ...(type_operation === 'group' && { group_balance_from: id }),
    }

    asideModalStore.activity(ms, bo)
  }

  // Перевод бонусного баланса между компаниями группами
  const transferBonus = (id, max_sum, type_operation, name) => {
    const ms = {
      modalBodyComponent: () => <Refunds translate={translate} transferBonus />,
      link: 'ledger/client_bonusbalance',
      button: translate.transfer,
      title: `Перевод бонуса: ${name}`,
      onSubmitSuccess: (data) => {
        setBalance([
          data.company_balances,
          data.bonus_balance,
          data.group_balances,
        ])
        data.company_balances.length > 0 &&
          setCompanyId(data.company_balances[0].company.id)
      },
      isResponsive: true,
      send: true,
      type_operation,
      payload: {
        companies: balance[0],
        groups: balance[2],
      },
      func,
    }

    const bo = {
      client: clientID,
      sum: max_sum,
      company_from: companyId,
      //company_to: companyId,
      type_operation: 'transfer',
    }

    asideModalStore.activity(ms, bo)
  }

  // Пополнение бонуса
  const topUpBonus = (id, max_sum, type_operation) => {
    const ms = {
      modalBodyComponent: () => <Refunds translate={translate} />,
      link: 'ledger/client_bonusbalance',
      button: 'Пополнить',
      title: `Пополнение бонуса`,
      onSubmitSuccess: (data) => {},
      isResponsive: true,
      type_operation,
    }

    const bo = {
      client: clientID,
      sum: max_sum,
      company_to: companyId,
      type_operation: 'add',
    }

    asideModalStore.activity(ms, bo)
  }

  // Списание бонуса
  const deleteBonus = (id, max_sum, type_operation) => {
    const ms = {
      modalBodyComponent: () => <Refunds translate={translate} />,
      link: 'ledger/client_bonusbalance',
      button: 'Списать',
      title: `Списание бонуса`,
      type: 'refundModal',
      onSubmitSuccess: (data) => {},
      isResponsive: true,
      type_operation,
    }

    const bo = {
      client: clientID,
      sum: max_sum,
      company_to: companyId,
      type_operation: 'delete',
    }

    asideModalStore.activity(ms, bo)
  }

  // Создание баланса компании
  const createBalances = () => {
    const ms = {
      modalBodyComponent: () => <CreateBalance />,
      button: 'Save',
      link: 'ledger/company_balance',
      title: 'Adding a company balance',
      onSubmitSuccess: (data) => {
        data.company_balances.length > 0 &&
          setCompanyId(data.company_balances[0].company.id)
      },
      isResponsive: true,
      valid: {
        company: 'required',
      },
    }
    const md = {
      client: clientID,
    }
    asideModalStore.activity(ms, md)
  }

  // Пополнение Money
  const addMoney = () => {
    const body = {
      modalBodyComponent: () => <AddMoney />,
      link: 'ledger/client_coins',
      button: 'Пополнить',
      title: `Пополнить Interpress Money`,
      isResponsive: true,
      onSubmitSuccess: () => {
        props.fetchClient(props.clientId)
      },
      valid: {
        sum: 'required',
        comment: 'required',
      },
    }
    asideModalStore.activity(body, { client: clientID })
  }

  // Списание Money
  const removeMoney = () => {
    const body = {
      modalBodyComponent: () => <AddMoney remove sum={props.coinSum} />,
      link: 'ledger/client_coins',
      button: 'Списать',
      title: `Списать Interpress Money`,
      isResponsive: true,
      onSubmitSuccess: () => {
        props.fetchClient(props.clientId)
      },
      onBeforeSubmit: (data) => {
        return {
          ...data,
          sum: -data?.sum,
        }
      },
      valid: {
        sum: 'required',
      },
    }
    asideModalStore.activity(body, { client: clientID })
  }

  useEffect(() => {
    fetchBalances()
  }, [])

  const { translate } = useLocalization({
    section: 'profile',
    subsection: 'my_balances',
    dict: {
      title: 'My Balances',
      add_new_company_balance: 'Add New Company Balance',
      free_balance_company: 'Company Balance',
      bonus_balance: 'Bonus balance',
      group: 'Group',
      top_up_balance: 'Top Up Balance',
      money_refund: 'Money Refund',
      money_transfer: 'Money Transfer',
      my_invoices: 'My Invoices',
      bonus_transfer: 'Bonus Transfer',
      top_up_bonus: 'Top Up Bonus',
      bonus_deduction: 'Bonus Deduction',
      transfer_to_student: 'Transfer to student',
      choose_student: 'Choose a student',
      amount: 'Amount',
      comment: 'Comment',
      transfer: 'Transfer',
      cancel: 'Cancel',
    },
  })

  const menu = [
    { name: translate.top_up_balance, action: 'top_up' },
    {
      name: translate.money_refund,
      action: 'refund',
      permission: permissions.add_refunds_transfers,
    },
    {
      name: translate.money_transfer,
      action: 'transfer',
      permission: permissions.add_refunds_transfers,
    },
    {
      name: translate.my_invoices,
      link: { to: `/pays/client-orders/${clientID}`, target: '_blank' },
      permission: permissions.view_client_orders_history,
    },
  ]

  const menu_free_balance = [
    { name: translate.top_up_balance, action: 'top_up' },
    {
      name: translate.transfer_to_student,
      action: 'transfer_to_student',
      permission: permissions.transfer_company_balance_other_client,
    },
    {
      name: translate.money_refund,
      action: 'refund',
      permission: permissions.add_refunds_transfers,
    },
    {
      name: translate.money_transfer,
      action: 'transfer',
      permission: permissions.add_refunds_transfers,
    },
    {
      name: translate.my_invoices,
      link: { to: `/pays/client-orders/${clientID}`, target: '_blank' },
      permission: permissions.view_client_orders_history,
    },
    {
      name: 'Пополнить Interpress Money',
      action: 'add_money',
      permission: permissions.add_client_coin,
    },
    {
      name: 'Списать Interpress Money',
      action: 'remove_money',
      permission: permissions.add_client_coin,
    },
  ]

  const bonusMenu = [
    {
      name: translate.bonus_transfer,
      action: 'transferBonus',
      permission: permissions.change_bonus_balance,
    },
    {
      name: translate.top_up_bonus,
      action: 'top_up_bonus',
      permission: permissions.add_bonus_balance,
    },
    {
      name: translate.bonus_deduction,
      action: 'delete_bonus',
      permission: permissions.delete_bonus_balance,
    },
    {
      name: translate.my_invoices,
      link: { to: `/pays/client-orders/${clientID}`, target: '_blank' },
      permission: permissions.view_client_orders_history,
    },
  ]

  const actions = (action, e, items) => {
    switch (action) {
      case 'transfer_to_student':
        {
          const { id, sum } = items.transferToStudent
          if (sum > 0) {
            transferStudent(id, sum)
          } else {
            swal({
              title: 'Перевод бонуса не возможен!',
              text: 'Для перевода средств баланс должен быть выше нуля.',
            })
          }
        }
        break
      case 'top_up':
        {
          const { id, name, isCompany } = items.topUp
          topUp(name, id, isCompany)
        }
        break
      case 'transfer':
        {
          const { id, sum, type_operation, name } = items.transfer
          if (sum > 0) {
            transfer(id, sum, type_operation, name)
          } else {
            swal({
              title: 'Перевод бонуса не возможен!',
              text: 'Для перевода средств баланс должен быть выше нуля.',
            })
          }
        }
        break
      case 'transferBonus':
        {
          const { id, sum, type_operation, name } = items.transferBonus
          if (sum > 0) {
            transferBonus(id, sum, type_operation, name)
          } else {
            swal({
              title: 'Перевод бонуса не возможен!',
              text: 'Для перевода бонус должен быть выше нуля.',
            })
          }
        }
        break
      case 'top_up_bonus':
        {
          const { id, sum, type_operation } = items.topUpBonus
          topUpBonus(id, sum, type_operation)
        }
        break
      case 'delete_bonus':
        {
          const { id, sum, type_operation } = items.deleteBonus
          if (sum > 0) {
            deleteBonus(id, sum, type_operation)
          } else {
            swal({
              title: 'Списание бонуса не возможено!',
              text: 'Для списание бонус должен быть выше нуля.',
            })
          }
        }
        break
      case 'refund':
        {
          const { id, sum, type_operation, name } = items.transfer
          if (sum > 0) {
            refund(id, sum, type_operation, name)
          } else {
            swal({
              title: 'Возврат средств не возможен!',
              text: 'Для возврата средств баланс должен быть выше нуля.',
            })
          }
        }
        break
      case 'add_money':
        addMoney()
        break
      case 'remove_money':
        removeMoney()
        break
      default:
        break
    }
  }

  return (
    <div className={st.clientBalances}>
      <BlockHeader title={translate.title} />
      {balance?.length > 0 ? (
        <>
          {balance[0]?.length > 0 ? (
            <>
              <div className={st.tabs}>
                {balance[0].map((item) => (
                  <span
                    key={item.company.id}
                    onClick={() => onChangeCompanyHandler(item.company.id)}
                    className={`${st.tab} ${item.company.id === companyId ? st.tabActive : ''}`}
                  >
                    {item.company.name}
                  </span>
                ))}
                <span
                  onClick={createBalances}
                  className={`${st.tab} ${st.tabActive} ${st.tabAdd}`}
                >
                  + {translate.add_new_company_balance}
                </span>
              </div>
              <div className={st.companySelect}>
                <SelectCustom
                  options={balance[0].map((bal) => ({
                    value: bal.company.id,
                    label: bal.company.name,
                  }))}
                  valueID={companyId}
                  onChange={(opt) => onChangeCompanyHandler(opt.value)}
                />
              </div>
            </>
          ) : (
            <EmptyBalance
              createBalances={createBalances}
              translate={translate}
            />
          )}

          {balance[0]?.length > 0 &&
            balance[0]
              .filter((x) => x.company.id === companyId)
              .map((item) => (
                <Fragment key={item.id}>
                  <div className={`${st.card} ${st.cardFirst}`}>
                    <div className={st.name}>
                      {translate.free_balance_company}:
                    </div>
                    <div className={st.sum}>
                      {Stores.cleanSumm(item.sum / 100) + ' ₸'}
                    </div>
                    <div className={st.topUp}>
                      <button
                        className={st.topUpButton}
                        onClick={() => {
                          topUp(
                            'компания ' + item.company.name,
                            item.company.id,
                            true,
                          )
                        }}
                      >
                        <TopUpIcon />
                        <span>{translate.top_up_balance}</span>
                      </button>
                    </div>
                    <div className={st.actionMenu}>
                      <ActionMenu
                        menu={menu_free_balance}
                        action={actions}
                        items={{
                          transferToStudent: {
                            id: item.id,
                            sum: item.sum,
                          },
                          topUp: {
                            name: 'компания ' + item.company.name,
                            id: item.company.id,
                            isCompany: true,
                          },
                          transfer: {
                            id: item.id,
                            sum: item.sum,
                            type_operation: 'company',
                            name: 'компания ' + item.company.name,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className={`${st.card} ${st.cardFirst}`}>
                    <div className={st.name}>{translate.bonus_balance}:</div>
                    <div className={st.balancesBlock}>
                      {balance[1] &&
                        balance[1]
                          .filter((el) => el.company_id === companyId)
                          .map((item, index) => (
                            <Fragment key={index}>
                              <div className={st.bonusBalance}>
                                <span className={st.title}>
                                  Blocked Balance:
                                </span>
                                <div className={st.value}>
                                  {Stores.cleanSumm(item.blocked_sum / 100)}
                                  <span> ₸</span>
                                </div>
                              </div>
                              <div className={st.sum}>
                                {Stores.cleanSumm(item.bonus_balance / 100) +
                                  ' ₸'}
                              </div>
                            </Fragment>
                          ))}
                    </div>
                    <div className={st.topUp} />
                    <div className={st.actionMenu}>
                      <ActionMenu
                        menu={bonusMenu}
                        action={actions}
                        items={{
                          transfer: {
                            id: item.id,
                            sum:
                              balance[1] &&
                              balance[1]
                                .filter((el) => el.company_id === companyId)
                                .map((el) => el.bonus_balance)
                                .join(),
                            type_operation: 'bonus_balance',
                            name: 'компания ' + item.company.name,
                          },
                          transferBonus: {
                            id: item.id,
                            sum:
                              balance[1] &&
                              balance[1]
                                .filter((el) => el.company_id === companyId)
                                .map((el) => el.bonus_balance)
                                .join(),
                            type_operation: 'transfer_bonus',
                            name: 'компания ' + item.company.name,
                          },
                          topUpBonus: {
                            id: item.id,
                            sum:
                              balance[1] &&
                              balance[1]
                                .filter((el) => el.company_id === companyId)
                                .map((el) => el.bonus_balance)
                                .join(),
                            type_operation: 'top_up_bonus',
                          },
                          deleteBonus: {
                            id: item.id,
                            sum:
                              balance[1] &&
                              balance[1]
                                .filter((el) => el.company_id === companyId)
                                .map((el) => el.bonus_balance)
                                .join(),
                            type_operation: 'top_up_bonus',
                          },
                        }}
                      />
                    </div>
                  </div>
                </Fragment>
              ))}

          {balance[2]?.length > 0 &&
            balance[2]
              .filter((x) => x.group.company.id === companyId)
              .map((item) => (
                <div key={item.id} className={st.card}>
                  <div>
                    <div className={st.groupName}>
                      {translate.group} "{item.group.status.name}"
                    </div>
                    <div className={st.name}>
                      {item.group.number} - {item.group.name}
                    </div>
                  </div>
                  <div className={st.balancesBlock}>
                    {item.bonus_balance > 0 && (
                      <div className={st.bonusBalance}>
                        <span className={st.title}>Bonus Balance:</span>
                        <div className={st.value}>
                          {Stores.cleanSumm(item.bonus_balance / 100)}
                          <span> ₸</span>
                        </div>
                      </div>
                    )}
                    <div
                      className={`${st.sum} ${item.sum < 0 ? st.negativeValue : ''}`}
                    >
                      {Stores.cleanSumm(item.sum / 100) + ' ₸'}
                    </div>
                  </div>
                  <div className={st.topUp}>
                    {item.group.status.id !== 6 &&
                      item.group.status.id !== 7 && (
                        <button
                          className={st.topUpButton}
                          onClick={() => {
                            topUp(
                              `${item.group.number} - ${item.group.name}`,
                              item.group.id,
                            )
                          }}
                        >
                          <TopUpIcon />
                          <span>{translate.top_up_balance}</span>
                        </button>
                      )}
                  </div>
                  <div className={st.actionMenu}>
                    <ActionMenu
                      menu={menu.filter(
                        (opt) =>
                          !(
                            opt.action === 'top_up' &&
                            (item.group.status.id === 6 ||
                              item.group.status.id === 7)
                          ),
                      )}
                      action={actions}
                      items={{
                        topUp: {
                          name: `${item.group.number} - ${item.group.name}`,
                          id: item.group.id,
                          isCompany: false,
                        },
                        transfer: {
                          id: item.id,
                          sum: item.sum,
                          type_operation: 'group',
                          name: `${item.group.number} - ${item.group.name}`,
                        },
                      }}
                    />
                  </div>
                </div>
              ))}
        </>
      ) : (
        <Loader />
      )}
    </div>
  )
}
